// String utilities
export function truncateText(text: string, maxLength: number): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength) + "...";
}

export function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export function capitalizeFirst(text: string): string {
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

export function capitalizeWords(text: string): string {
  return text
    .split(" ")
    .map((word) => capitalizeFirst(word))
    .join(" ");
}

/**
 * Formats a brand name from backend format to proper display format
 * Handles title case and special accents for luxury brands
 * @param brandName - The brand name from backend (e.g., "chanel", "hermes")
 * @returns Properly formatted brand name (e.g., "Chanel", "Hermès")
 */
export function formatBrandName(brandName: string): string {
  if (!brandName) return brandName;

  const brandNameLower = brandName.toLowerCase().trim();
  
  // Special cases for brands with accents or unique formatting
  const specialBrands: Record<string, string> = {
    "hermes": "Hermès",
    "bvlgari": "Bvlgari",
    "off white": "Off-White",
    "the row": "The Row",
  };

  // Check if it's a special brand first
  if (specialBrands[brandNameLower]) {
    return specialBrands[brandNameLower];
  }

  return capitalizeWords(brandNameLower);
}


